import {lineNumber, syntaxError} from './rulesUtils.mjs';

class InvalidLine {
    consume(tokenIterator) {
        throw syntaxError(lineNumber(tokenIterator), 'Expected a # unit title or ## page name');
    }
}

export {InvalidLine};
